import './WhyUs.css';

const reasons = [
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>,
    title: 'Results-Driven Approach',
    desc: 'Every decision is driven by one question: will this help our client achieve their goal? We measure success by your outcomes, not just project completion.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    title: 'Transparent Communication',
    desc: 'You will never wonder about your project status. Regular updates via WhatsApp and email, progress reports, and always available to answer questions.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
    title: 'Fast Turnaround Times',
    desc: 'We understand that time is money. Our streamlined processes deliver high-quality work faster — a basic website in 3–5 days, a research paper edit in 24 hours.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
    title: 'Complete Confidentiality',
    desc: 'Every project is protected by a strict service agreement. Your business ideas, research data, and personal information are never shared with third parties.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
    title: 'Transparent & Fair Pricing',
    desc: 'Our pricing is published openly. No hidden fees, no surprise invoices. Every package has a clear price range and a detailed list of what is included.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
    title: 'Post-Delivery Support',
    desc: 'Our relationship does not end at delivery. We offer free support for 7–14 days post-delivery and maintenance packages for ongoing needs.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
    title: '10+ Successful Projects',
    desc: 'With 10+ projects delivered across web development, AI solutions, and research services, we bring real-world experience to every engagement.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
    title: 'Full-Service Under One Roof',
    desc: 'From website design to AI integration to research paper editing — we handle it all under one roof, delivering faster and better results.',
  },
];

export default function WhyUs() {
  return (
    <section className="whyus-section" id="why-us">
      <div className="container">
        <div className="section-header" style={{ textAlign: 'center', marginBottom: 60 }}>
          <span className="section-tag">Why Choose Us</span>
          <h2 className="whyus-title">Why 10+ Clients Trust <span>LathiNyx DevLabs™</span></h2>
          <p className="whyus-sub">We are not just another digital agency. Here is what makes us different — and why our clients keep coming back.</p>
        </div>
        <div className="whyus-grid">
          {reasons.map(r => (
            <div key={r.title} className="whyus-card">
              <div className="whyus-icon">{r.icon}</div>
              <h3 className="whyus-card-title">{r.title}</h3>
              <p className="whyus-card-desc">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
